import React from 'react'

const Price = ( {originalPrice, salePrice}) => {
  return (
    <div className="book__price">
    {salePrice ? (
      <>
        {" "}
        <span className="book__price--normal">
          Lek {originalPrice.toFixed(2)}
        </span>
        Lek {salePrice.toFixed(2)}
      </>
    ) : (
      <>Lek {originalPrice.toFixed(2)}</>
    )}
  </div>
  )
}

export default Price
